import {createRouter, createWebHistory} from 'vue-router'
import i18n from '@/i18n'
import store from '@/store'

import HomeView from '../views/site/HomeView.vue'
import LoginView from '../views/site/LoginView.vue'
import FAQView from '../views/site/FAQView.vue'
import PhoneRegiseterView from '../views/site/PhoneRegisterView.vue'
import EmailRegisterView from '../views/site/EmailRegisterView.vue'
import ContactView from '../views/site/ContactView.vue'
import AboutView from '../views/site/AboutView.vue'
import CheckerRegister from '../views/checker/CheckerRegisterView.vue'
import CreateProjectView from '@/views/user/CreateProjectView'
import BlogItem from '../views/site/BlogItem.vue'
import BlogsPage from '../views/site/BlogsPage.vue'
import PrivacyPolicy from '../views/site/PrivacyPolicy.vue'
import TermsConditions from '../views/site/TermsConditions.vue'
import ReturnsPolicy from '../views/site/ReturnsPolicy.vue'
import CheckerDashboard from '../views/checker/CheckerDashboardView.vue'
import Projects from '../views/user/ProjectsView.vue'
import ServicesView from '@/views/user/ServicesView'
import ProjectDetails from '@/views/user/ProjectDetails'
import ProjectPreview from '@/views/user/ProjectPreview'
import UnAuthComponent from '@/views/site/UnAuthComponent'
import checkerProjectDetails from '@/views/checker/CheckerProjectDetails'
import CheckerProjectFrom from '@/views/checker/CheckerProjectFrom'
import UpdateProjectView from '@/views/user/UpdateProjectView'
import MyProfile from '@/views/site/MyProfile'
import ResetPasswordView from '@/views/site/ResetPasswordView'

const routes = [
    {path: '/:locale(en)?/', name: 'home', component: HomeView},
    {path: '/:locale(en)?/login', name: 'login', component: LoginView},
    {path: '/:locale(en)?/password-reset', name: 'password-reset', component: ResetPasswordView},
    {path: '/:locale(en)?/faq', name: 'faq', component: FAQView},
    {path: '/:locale(en)?/regph', name: 'regph', component: PhoneRegiseterView},
    {path: '/:locale(en)?/register', name: 'register', component: EmailRegisterView},
    {path: '/:locale(en)?/contact', name: 'contact', component: ContactView},
    {path: '/:locale(en)?/about', name: 'about', component: AboutView},
    {
        path: '/:locale(en)?/services',
        name: 'services',
        component: ServicesView,
        meta: {requiresAuth: true, onlyUsers: true}
    },
    {path: '/:locale(en)?/register-as-checker', name: 'register-as-checker', component: CheckerRegister},
    {
        path: '/:locale(en)?/new-project',
        name: 'new-project',
        component: CreateProjectView,
        meta: {requiresAuth: true, onlyUsers: true}
    },
    {
        path: '/:locale(en)?/update-project/:id',
        name: 'update-project',
        component: UpdateProjectView,
        meta: {requiresAuth: true, onlyUsers: true}
    },
    {
        path: '/:locale(en)?/checker-dashboard',
        name: 'checker-dashboard',
        component: CheckerDashboard,
        meta: {requiresAuth: true, onlyCheckers: true}
    },
    {
        path: '/:locale(en)?/checker-project-details/:id',
        name: 'checker-project-details',
        component: checkerProjectDetails,
        meta: {requiresAuth: true, onlyCheckers: true}
    },
    {
        path: '/:locale(en)?/checker-project-form/:id',
        name: 'checker-project-form',
        component: CheckerProjectFrom,
        meta: {requiresAuth: true, onlyCheckers: true}
    },
    {
        path: '/:locale(en)?/projects',
        name: 'projects',
        component: Projects,
        meta: {requiresAuth: true, onlyUsers: true}
    },
    {path: '/:locale(en)?/un-auth', name: 'un-auth', component: UnAuthComponent},
    {
        path: '/:locale(en)?/project-details/:id',
        name: 'project-details',
        component: ProjectDetails,
        meta: {requiresAuth: true, onlyUsers: true}
    },
    {
        path: '/:locale(en)?/project-preview/:id',
        name: 'project-preview',
        component: ProjectPreview,
        meta: {requiresAuth: true, onlyUsers: true}
    },
    {path: '/:locale(en)?/blog/:id', name: 'blog-item', component: BlogItem},
    {path: '/:locale(en)?/blogs', name: 'blogs-page', component: BlogsPage},
    {path: '/:locale(en)?/privacy-policy', name: 'privacy-policy', component: PrivacyPolicy},
    {path: '/:locale(en)?/terms-conditions', name: 'terms-conditions', component: TermsConditions},
    {path: '/:locale(en)?/returns-policy', name: 'returns-policy', component: ReturnsPolicy},
    {path: '/:locale(en)?/my-profile', name: 'my-profile', component: MyProfile, meta: {requiresAuth: true}}
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    linkActiveClass: 'activeLink'
})

router.beforeEach((to, from, next) => {
    const currentLocale = to.params.locale || 'ar'
    i18n.global.locale = currentLocale

    // If locale is Arabic, strip any /en or /ar prefix from the URL
    if (currentLocale === 'ar' && (to.fullPath.startsWith('/en') || to.fullPath.startsWith('/ar'))) {
        const newPath = to.fullPath.replace(/^\/(en|ar)/, '') || '/'
        return next({path: newPath, replace: true})
    }

    // If locale is English, ensure the URL starts with /en
    if (currentLocale === 'en' && !to.fullPath.startsWith('/en')) {
        const newPath = `/en${to.fullPath}`
        return next({path: newPath, replace: true})
    }

    if (to.meta?.requiresAuth && !store.getters.user) {
        return next({name: 'login', params: {locale: currentLocale}})
    }

    if (store.getters.isCheckerUser && to.meta?.onlyUsers) {
        return next({name: 'un-auth', params: {locale: currentLocale}})
    }

    if (!store.getters.isCheckerUser && to.meta?.onlyCheckers) {
        return next({name: 'un-auth', params: {locale: currentLocale}})
    }

    next();
})
export default router;